import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { 
  CreditCardIcon, 
  AcademicCapIcon, 
  OfficeBuildingIcon 
} from "@heroicons/react/outline";
import ConsultantMenuCard from "../../Components/ConsultantMenuCard";

const ConsultantMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const menuItems = useMemo(() => [
    {
      id: "consultant-transactions",
      title: t("Consultant Transactions"),
      description: t("Displaying information about your transaction and consultation balance."),
      icon: CreditCardIcon,
      iconForeground: "text-blue-600",
      iconBackground: "bg-blue-50",
      onClick: () => navigate("/consultant-transaction"),
    },
    {
      id: "manage-tutoring",
      title: t("Manage Tutoring Program"),
      description: t("Manage the tutoring program that you offer to customers."),
      icon: AcademicCapIcon,
      iconForeground: "text-green-600",
      iconBackground: "bg-green-50",
      onClick: () => navigate("/manage-tutoring"),
    },
    {
      id: "manage-business-service",
      title: t("manageBusinessServiceListTitle"),
      description: t("manageBusinessServicesDesc"),
      icon: OfficeBuildingIcon,
      iconForeground: "text-teal-600",
      iconBackground: "bg-teal-50",
      onClick: () => navigate("/manage-business-service"),
    },
  ], [t, navigate]);

  return (
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-6 gap-4">
        {menuItems.map((item) => (
          <ConsultantMenuCard key={item.id} menuItem={item} />
        ))}
      </div>
    </div>
  );
};

export default ConsultantMenu;
